var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M312.593 384H361.728C354.523 346.818 341.062 311.928 322.661 280.186L282.327 306.113C296.007 330.148 306.277 356.309 312.593 384ZM213.661 224.771C233.052 240.582 250.169 258.986 264.896 279.254L305.312 253.271C285.747 225.893 262.189 201.66 235.48 181.238L213.661 224.771ZM416.009 416H83.79L252.634 78.312C260.54 62.5 254.134 43.281 238.322 35.375C222.509 27.484 203.322 33.875 195.384 49.687L3.384 433.687C-1.585 443.609 -1.053 455.391 4.79 464.828C10.634 474.25 20.915 480 32.009 480H416.009C433.697 480 448.009 465.672 448.009 448S433.697 416 416.009 416Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngle);
export default __webpack_public_path__ + "static/media/angle.2b3318c6cd54668332c1406baf574198.svg";
export { ForwardRef as ReactComponent };